import './action_bar.less';

import classNames from 'classnames';
import compact from 'lodash/compact';
import filter from 'lodash/filter';
import map from 'lodash/map';
import React, { Fragment, Component } from 'react';
import slice from 'lodash/slice';
import withOnClickOutside from 'react-onclickoutside';

import Button from 'zoomforth_component_lib/btn_basic.jsx';
import Tipsy from 'zoomforth_component_lib/tipsy.jsx';
import { CloseIcon, PlusIcon, FolderIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';


const MAX_ACTIVE_ASSET_TYPES_FOR_DISPLAY = 3;

const DivWithOnClickOutside = withOnClickOutside(class Tmp extends Component {
  handleClickOutside() {
    this.props.onClickOutside();
  }
  render() {
    return <div className={this.props.className} children={this.props.children} />;
  }
});


const ActiveAssetSearchItem = ({ title, type, onMediaTypeSearchDeactivate })=>
  <Tipsy content={`Remove "${title}"`} mouseEnterDelay={.3}>
    <div
      className="active-asset-type-search-item" 
      onClick={()=> { onMediaTypeSearchDeactivate(type); }}
    >
      {title}
      <div className="remove-item">
        <CloseIcon />
      </div>
    </div>
  </Tipsy>;


const MediaLibraryActionBar = ({ 
  assetTypeData,
  isInSearchMode,
  isMediaTypesDropdownActive,
  isExtraActiveCurrentFiltersDropdownShown,
  shouldDeemphasizeUpload,
  textSearch,
  onAddFolderClick,
  onAddMediaClick,
  onMediaTypeSearchActivate,
  onMediaTypeSearchDeactivate,
  onExtraActiveCurrentFiltersDropdownShow,
  onExtraActiveCurrentFiltersDropdownHide,
  onMediaTypesDropdownShow,
  onMediaTypesDropdownHide,
  onTextSearchChange
})=> {

  const activeAssetTypeData = compact(filter(assetTypeData, 'isActive'));


  return (
    <div className="media-library-action-bar">
      <div className="folder-action-buttons">
        <Fragment>
          <Button 
            type={shouldDeemphasizeUpload ? 'secondary' : 'primary'}
            disabled={isInSearchMode}
            tooltip={isInSearchMode ? 'You cannot upload media while searching—clear your search to upload.' : undefined}
            className="action-add-media folder-action-button"
            onClick={onAddMediaClick}
          >
            <PlusIcon /> Upload Media
          </Button>
          <Button 
            secondary
            disabled={isInSearchMode}
            tooltip={isInSearchMode ? 'You cannot create a folder while searching—clear your search to create a folder.' : undefined}
            className="action-add-folder folder-action-button"
            onClick={onAddFolderClick}
          >
            <FolderIcon /> Create Folder
          </Button>
        </Fragment>
      </div>

      <div className="search-box-wrapper">
        <input 
          type="text" 
          name="search" 
          className="action-search-box" 
          placeholder="Search" 
          value={textSearch} 
          onChange={(e)=> {
            onTextSearchChange(e.target.value);
          }}
        />
        { textSearch &&
          <div className="clear-search-button action-clear-search" onClick={()=> { onTextSearchChange(''); }}>
            <CloseIcon />
          </div>
        }
        <DivWithOnClickOutside className="filter-search-wrapper" onClickOutside={onMediaTypesDropdownHide}>
          <div className="filter-button action-filter-button" onClick={onMediaTypesDropdownShow}>
            Search by Type
            <i className="fa fa-sort-desc"></i>
          </div>
          <div className="search-filter-dropdown" style={{ display: isMediaTypesDropdownActive ? 'block':'none'}}>
            { map(
                assetTypeData,
                ({ type, isActive, isDisabled, title }, index)=>
                  <div 
                    key={index}
                    className={classNames('filter-option action-filter-option', {
                      'is-active':isActive, 'is-disabled':isDisabled
                    })}
                    onClick={
                      !(isActive || isDisabled) ?
                        ()=> { 
                          onMediaTypesDropdownHide();
                          onMediaTypeSearchActivate(type); 
                        }
                      : 
                        undefined
                    }
                  >
                    {title}
                  </div>
            )}

          </div>
        </DivWithOnClickOutside>
      </div>
      <div className="active-asset-type-searches">
        { 
          // For less than MAX_ACTIVE... media search types just display filter
          map(
            slice(activeAssetTypeData, 0, MAX_ACTIVE_ASSET_TYPES_FOR_DISPLAY), 
            ({ type, title }, index)=>
              <ActiveAssetSearchItem key={index} {...{title, type, onMediaTypeSearchDeactivate}} />
          )
        }
        {
          // For more than MAX_ACTIVE... media search types display an ellipse button
          activeAssetTypeData.length > MAX_ACTIVE_ASSET_TYPES_FOR_DISPLAY && (
          
            isExtraActiveCurrentFiltersDropdownShown ?

              <DivWithOnClickOutside 
                className="extra-active-current-filters-dropdown" 
                onClickOutside={onExtraActiveCurrentFiltersDropdownHide}
              >
                { map(
                    slice(activeAssetTypeData, MAX_ACTIVE_ASSET_TYPES_FOR_DISPLAY), 
                    ({ type, title }, index)=>
                      <ActiveAssetSearchItem key={index} {...{title, type, onMediaTypeSearchDeactivate}} />
                  )
                }          
              </DivWithOnClickOutside>
            :
              <div 
                className="active-asset-type-search-item"
                onClick={onExtraActiveCurrentFiltersDropdownShow}
              >
                {activeAssetTypeData.length - MAX_ACTIVE_ASSET_TYPES_FOR_DISPLAY} more&hellip;
              </div>
          )  
        }
      </div>
    </div>
  );
};

export default MediaLibraryActionBar;